import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/components/LandingPage";
import ApplyPage from "@/components/ApplyPage";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import ReferAFriend from "@/components/ReferAFriend";
import TradeIn from "@/components/TradeIn";
import Calculator from "@/components/Calculator";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/refer-a-friend" element={<ReferAFriend />} />
            <Route path="/trade-in" element={<TradeIn />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
